module.exports = __webpack_public_path__ + "static/img/about_14.b9964be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_14.png
// module id = 1rdY
// module chunks = 1